var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/145d3b2a72173e5e8aed71d10b4d4947.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/175451f3d488f1d9f75cb6e46e77a1c5.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1fce0fbeabf5d90dd973ab8058575baa.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/30482a63e7061c8a9cfc4b0c1c68ebb0.js').default;
var scope_4 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/50030cc7bc9b7313648399e08108d66a.js').default;
var scope_5 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/51813c08d0c21c9071b61b5d69a04865.js').default;
var scope_6 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5a1f39540cd3a49ce7fea7b2d9a691e7.js').default;
var scope_7 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5b1fbb2a7b8c10bd79af8abab1a64fec.js').default;
var scope_8 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5ba2c5c069a06950b94e8dc140cdc79e.js').default;
var scope_9 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7f6ec171170e10788615f20bd69d115f.js').default;
var scope_10 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9ec4c26795ee202182aa1794b0e67da4.js').default;
var scope_11 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a2532389f584adcdec8d2b18cc0b6ff3.js').default;
var scope_12 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ad798c388390559bc8e9abc5250de1c7.js').default;
var scope_13 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b1c47e9cc5123676bdc442dcf4199516.js').default;
var scope_14 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b8b5872270be6f456261cd9b704eaf84.js').default;
var scope_15 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b9d0a7f9c829c14619202f1682056c4c.js').default;
var scope_16 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d1ec9f0bbec5914b30e362234d339aa6.js').default;
var scope_17 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d6b8102ef9eec2b5546c464a16c82eb9.js').default;
var scope_18 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e2c6851ee40e74a9294fc3bed508b1c8.js').default;
var scope_19 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e4a1001d2b228e98220901b2dfe97d30.js').default;
var scope_20 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e5bd78b01418abe62da11ad16ceb335f.js').default;
var scope_21 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e695710f31f5e6d887c8c6bab1cf5543.js').default;
var scope_22 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_23 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f3b6bdd40d296a27c92eb2c8087cc4d0.js').default;
var scope_24 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f8a658573ae0fbfe43fa9530dc855c50.js').default;
var scope_25 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/faded7af6370b77f3c5ac87c7a097f5e.js').default;
var scope_26 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fc159dd572f17718865e8ccd3254db28.js').default;
var scope_27 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fe7217878c96c1142d778f4038bb67d1.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16,
scope_17,
scope_18,
scope_19,
scope_20,
scope_21,
scope_22,
scope_23,
scope_24,
scope_25,
scope_26,
scope_27 )
    